import { isBefore } from 'date-fns';

const handleAfterTicketSellsOut = ({ entity, entityKey, allEntities, checkSoldOutFunc, now }) => {
  // Check if referenced ticket is sold out
  if (!entity[entityKey]) return false;

  const reference = allEntities.find(tt => tt._id === entity[entityKey]);
  if (!reference || reference.status !== 'enabled') return false;

  const isTriggerSoldOut = checkSoldOutFunc(reference);

  if (!isTriggerSoldOut) return false;

  const saleEndOn = entity.saleEndOn ? new Date(entity.saleEndOn) : null;
  const isBeforeEnd = saleEndOn ? isBefore(now, saleEndOn) : true;

  return isBeforeEnd;
};

export default handleAfterTicketSellsOut;
